window.MTGGoldfish = window.MTGGoldfish || {};
window.MTGGoldfish.onDocumentReadyArray = window.MTGGoldfish.onDocumentReadyArray || [];
window.MTGGoldfish.onDocumentReadyArray.push(function() { 
  //$('.textfill').textfill();
  $('.textfill').textfill({ maxFontPixels: 75});
  $('.deck-visual-footer-copyright').textfill({ maxFontPixels: 10});
  //$('.deck-visual-header-title-info').textfill({ maxFontPixels: 20});
  
  pieChart(); 
});

function pieChart() {

  // Set things up and draw the chart
  init();

  /**
   * Set up the chart data and colours, as well as the chart and table click handlers,
   * and draw the initial pie chart
   */

  function init() {

    $("ins[data-type='donut-chart']").each (function() {
      var totalValue = 0;               // Total of all the values in the chart
      var canvasWidth;                  // Width of the canvas, in pixels
      var canvasHeight;                 // Height of the canvas, in pixels
      var centreX;                      // X-coordinate of centre of the canvas/chart
      var centreY;                      // Y-coordinate of centre of the canvas/chart

      // Get the canvas element in the page
  
      // Initialise some properties of the canvas and chart
      canvasWidth = $(this).data("width");
      canvasHeight = $(this).data("height");
      labelSize = $(this).data("lsize");
      if (labelSize  === undefined) {
        labelSize = 20;
      } else {
        labelSize = parseFloat(labelSize);
      }

      $(this).append("<canvas width=" + canvasWidth + " height=" + canvasHeight + ">");
      var canvas = $(this).find("canvas").get(0);
  
      // Exit if the browser isn't canvas-capable
      if ( typeof canvas.getContext === 'undefined' ) return;

      centreX = canvasWidth / 2;
      centreY = canvasHeight / 2;

      chartRadius = Math.min( canvasWidth, canvasHeight ) / 2;
      chartRadiusInner = 0.33 * chartRadius;

  
      // Grab the data from the table,
      // and assign click handlers to the table data cells
      
      var slices = [];

      $(this).find("ins[data-type='donut-chart-entry']").each (function() {
        slice = {}
        slice['value'] = parseFloat($(this).data("value"));
        slice['label'] = $(this).data("label");
        slice['background'] = $(this).data("background");

        slices.push(slice);

        totalValue += slice['value']
      });

      // Now compute and store the start and end angles of each slice in the chart data
      var currentPos = 0; // The current position of the slice in the pie (from 0 to 1)
      for ( var slice in slices ) {
        slices[slice]['startAngle'] = 2 * Math.PI * currentPos;
        slices[slice]['endAngle'] = 2 * Math.PI * ( currentPos + ( slices[slice]['value'] / totalValue ) );
        currentPos += slices[slice]['value'] / totalValue;
      }

      // All ready! Now draw the pie chart, and add the click handler to it
      drawChart(canvas, canvasWidth, canvasHeight, centreX, centreY, chartRadius, chartRadiusInner, labelSize, slices);
    });
  }

  /**
   * Draw the chart.
   *
   * Loop through each slice of the pie, and draw it.
   */

  function drawChart(canvas, canvasWidth, canvasHeight, centreX, centreY, chartRadius, chartRadiusInner, labelSize, slices) {

    // Get a drawing context
    var context = canvas.getContext('2d');
        
    // Clear the canvas, ready for the new frame
    context.clearRect ( 0, 0, canvasWidth, canvasHeight );

    // Draw each slice of the chart, skipping the pull-out slice (if any)
    var i = 0;
    for ( var slice in slices ) {
      drawSlice( context, slices[slice], centreX, centreY, chartRadius, chartRadiusInner, labelSize);
    }
  }

  /**
   * Draw an individual slice in the chart.
   *
   * @param Context A canvas context to draw on  
   * @param Number The index of the slice to draw
   */

  function drawSlice( context, slice, centreX, centreY, chartRadius, chartRadiusInner, labelSize) {
    // Config settings
    var sliceBorderWidth = 1;                         // Width (in pixels) of the border around each slice
    var sliceBorderStyle = "#333430";                    // Colour of the border around each slice
    var chartStartAngle = -.5 * Math.PI;              // Start the chart at 12 o'clock instead of 3 o'clock

    var imageObj = new Image();
    imageObj.src = slice['background'];
    imageObj.onload = function() {

      var manaSymbol = new Image();
      manaSymbol.src = slice['label'];
      manaSymbol.onload = function() {

        var pattern = context.createPattern(imageObj, 'repeat');
        // Compute the adjusted start and end angles for the slice
        var startAngle = slice['startAngle']  + chartStartAngle;
        var endAngle = slice['endAngle']  + chartStartAngle;
    
        // This slice isn't pulled out, so draw it from the pie centre
        startX = centreX;
        startY = centreY;
    
        // Draw the slice
        context.beginPath();
        context.arc( startX, startY, chartRadius, startAngle, endAngle, false );
        context.arc( startX, startY, chartRadiusInner, endAngle, startAngle, true );
        context.closePath();

        context.fillStyle = pattern;
        context.fill();
        context.shadowColor = "rgba( 0, 0, 0, 0 )";
    
        context.lineWidth = sliceBorderWidth;
        context.strokeStyle = sliceBorderStyle;

        var theta = endAngle - 0.5*(endAngle - startAngle);

        var labelRadius = chartRadiusInner + 0.5*(chartRadius - chartRadiusInner);
        var labelX = labelRadius * Math.cos(theta);
        var labelY = labelRadius * Math.sin(theta);

        context.drawImage(manaSymbol,startX + labelX - 0.5*labelSize, startY + labelY - 0.5*labelSize, labelSize, labelSize);
    
        // Draw the slice border
        context.stroke();
      }
    }
  }

};

window.MTGGoldfish.onDocumentReadyArray.push(function() { 

  var legendHeight = 20;
  var canvasHeight = 150;
  var canvasWidth = 300;

  $("ins[data-type='bar-chart']").each (function() {
    // Initialise some properties of the canvas and chart
    canvasWidth = $(this).data("width");
    canvasHeight = $(this).data("height");

    $(this).append("<canvas width=" + canvasWidth + " height=" + canvasHeight + ">");
    var canvas = $(this).find("canvas").get(0);

    // Exit if the browser isn't canvas-capable
    if ( typeof canvas.getContext === 'undefined' ) return;

    var context = canvas.getContext('2d');
    context.clearRect ( 0, 0, canvasWidth, canvasHeight );

    var bars = [];
    var maxValue = 0;
    var background = $(this).data('background');

    $(this).find("ins[data-type='bar-chart-entry']").each (function() {
      const bar = {}
      bar['key'] = $(this).data('key');
      bar['value'] = parseFloat($(this).data('value'));
      bars.push(bar);

      if (bar['value'] > maxValue) {
        maxValue = bar['value'];
      }
    });

    var barStartY = legendHeight;
    var barLabelHeight = 20;
    var barWidth = canvasWidth/bars.length;
    var maxBarHeight = canvasHeight - barStartY - barLabelHeight; // subtract space for legend and x-axis

    var sliceBorderWidth = 1;                         // Width (in pixels) of the border around each slice
    var sliceBorderStyle = "#333430";                    // Colour of the border around each slice

    var imageObj = new Image();
    imageObj.src = background;
    imageObj.onload = function() {
      var pattern = context.createPattern(imageObj, 'repeat');
      for (var bar in bars) {
        var barHeight = maxBarHeight * bars[bar]['value']/maxValue;
        context.rect(bar*barWidth,barLabelHeight + maxBarHeight - barHeight,barWidth,barHeight);
        context.fillStyle = "#3abbf1";
        context.lineWidth = sliceBorderWidth;
        context.strokeStyle = sliceBorderStyle;

        context.fill();
        context.stroke();

        context.font = "bold 14px Open Sans";
        context.fillStyle = "#fff";
        //context.fillStyle = ($(".deck-visual-light-bg").length>0) ? "#333" : "#fff";
        context.textAlign = "center";
        context.fillText(bars[bar]['key'], bar*barWidth + barWidth/2, canvasHeight - 5);
        if (bars[bar]['value'] > 0) {
          context.fillText(bars[bar]['value'], bar*barWidth + barWidth/2, barLabelHeight + maxBarHeight - barHeight - 5);
        }
      }
    }
  });
});


